<template lang="pug">
.length
  label.length__label
    span.length__control(:class="{ error }")
      input(
        v-model="length",
        type="text",
        placeholder="Cable Length",
        inputmode="numeric",
        min="0",
        step="1",
        pattern="[0-9]+")
      em(:class="{ error }") inches
    SelectionError(:visible="error", :text="errorText")
</template>


<script>
import { mapGetters, mapMutations } from "vuex";
import SelectionError from "./SelectionError";
export default {
  name: "SelectorLength",
  components: {
    SelectionError,
  },
  data() {
    return {
      error: false,
      errorText: "Please enter a cable length.",
    };
  },
  computed: {
    ...mapGetters(["model", "touched"]),
    length: {
      get() {
        return this.model.length || "";
      },
      set(value) {
        value = Number(value);
        if (!value) value = 0;
       
        this.setModel({ parameter: "length", value });
      },
    },
  },
  methods: {
    ...mapMutations(["setModel"]),
    handleError() {
      this.error = this.touched && !this.length;
    },
  },
  watch: {
    touched() {
      this.handleError();
    },
    model: {
      deep: true,
      handler() {
        this.handleError();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.length {
  display: flex;
  margin: 0;

  &__label {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__control {
    display: flex;
    position: relative;
    border: 1px solid $midGray;
    height: 2.5rem;
    background: $white;
    flex: 0 0 auto;
    transition: 0.25s ease;

    &.error {
      border-color: $red;
    }

    input {
      padding: 0.75rem 1rem;
      position: relative;
      min-width: 115px;
      width: 0;
      height: 100%;
      appearance: none;
      border: none;
      background: transparent;
      margin: 0;
      font-size: 1rem;
      &::placeholder {
        font-size: 0.875rem;
      }
    }

    em {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 1;
      padding: 0.75rem 1rem;
      font-size: 0.75rem;
      font-style: normal;
      background: $midGray;
      transition: 0.25s ease;

      &.error {
        background: $buttonHighlightBackground;
        color: $buttonHighlightColor;
      }
    }
  }
}
</style>